module.exports = __webpack_public_path__ + "img/img_top2.475766bc.png";